/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ title: NonNullable<unknown>, version: NonNullable<unknown> }} Builds_Meta_TitleInputs */

const id_builds_meta_title = /** @type {(inputs: Builds_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} (${i?.version}) | egdata.app`)
};

const ms_builds_meta_title = /** @type {(inputs: Builds_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} (${i?.version}) | egdata.app`)
};

const da_builds_meta_title = /** @type {(inputs: Builds_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} (${i?.version}) | egdata.app`)
};

const de_builds_meta_title = /** @type {(inputs: Builds_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} (${i?.version}) | egdata.app`)
};

const en_us2_builds_meta_title = /** @type {(inputs: Builds_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} (${i?.version}) | egdata.app`)
};

const es_es2_builds_meta_title = /** @type {(inputs: Builds_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} (${i?.version}) | egdata.app`)
};

const es_mx2_builds_meta_title = /** @type {(inputs: Builds_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} (${i?.version}) | egdata.app`)
};

const fil_builds_meta_title = /** @type {(inputs: Builds_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} (${i?.version}) | egdata.app`)
};

const fr_builds_meta_title = /** @type {(inputs: Builds_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} (${i?.version}) | egdata.app`)
};

const it_builds_meta_title = /** @type {(inputs: Builds_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} (${i?.version}) | egdata.app`)
};

const hu_builds_meta_title = /** @type {(inputs: Builds_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} (${i?.version}) | egdata.app`)
};

const nl_builds_meta_title = /** @type {(inputs: Builds_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} (${i?.version}) | egdata.app`)
};

const no_builds_meta_title = /** @type {(inputs: Builds_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} (${i?.version}) | egdata.app`)
};

const pl_builds_meta_title = /** @type {(inputs: Builds_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} (${i?.version}) | egdata.app`)
};

const pt_br2_builds_meta_title = /** @type {(inputs: Builds_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} (${i?.version}) | egdata.app`)
};

const pt_builds_meta_title = /** @type {(inputs: Builds_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} (${i?.version}) | egdata.app`)
};

const ro_builds_meta_title = /** @type {(inputs: Builds_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} (${i?.version}) | egdata.app`)
};

const fi_builds_meta_title = /** @type {(inputs: Builds_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} (${i?.version}) | egdata.app`)
};

const sv_builds_meta_title = /** @type {(inputs: Builds_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} (${i?.version}) | egdata.app`)
};

const vi_builds_meta_title = /** @type {(inputs: Builds_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} (${i?.version}) | egdata.app`)
};

const tr_builds_meta_title = /** @type {(inputs: Builds_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} (${i?.version}) | egdata.app`)
};

const cs_builds_meta_title = /** @type {(inputs: Builds_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} (${i?.version}) | egdata.app`)
};

const bg_builds_meta_title = /** @type {(inputs: Builds_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} (${i?.version}) | egdata.app`)
};

const ru_builds_meta_title = /** @type {(inputs: Builds_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} (${i?.version}) | egdata.app`)
};

const uk_builds_meta_title = /** @type {(inputs: Builds_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} (${i?.version}) | egdata.app`)
};

const ar_builds_meta_title = /** @type {(inputs: Builds_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} (${i?.version}) | egdata.app`)
};

const hi_builds_meta_title = /** @type {(inputs: Builds_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} (${i?.version}) | egdata.app`)
};

const th_builds_meta_title = /** @type {(inputs: Builds_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} (${i?.version}) | egdata.app`)
};

const ja_builds_meta_title = /** @type {(inputs: Builds_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} (${i?.version}) | egdata.app`)
};

const zh_cn2_builds_meta_title = /** @type {(inputs: Builds_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} (${i?.version}) | egdata.app`)
};

const zh_hant1_builds_meta_title = /** @type {(inputs: Builds_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} (${i?.version}) | egdata.app`)
};

const ko_builds_meta_title = /** @type {(inputs: Builds_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} (${i?.version}) | egdata.app`)
};

/**
* | output |
* | --- |
* | "{title} ({version}) \| egdata.app" |
*
* @param {Builds_Meta_TitleInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const builds_meta_title = /** @type {((inputs: Builds_Meta_TitleInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builds_Meta_TitleInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builds_meta_title(inputs)
	if (locale === "ms") return ms_builds_meta_title(inputs)
	if (locale === "da") return da_builds_meta_title(inputs)
	if (locale === "de") return de_builds_meta_title(inputs)
	if (locale === "en-US") return en_us2_builds_meta_title(inputs)
	if (locale === "es-ES") return es_es2_builds_meta_title(inputs)
	if (locale === "es-MX") return es_mx2_builds_meta_title(inputs)
	if (locale === "fil") return fil_builds_meta_title(inputs)
	if (locale === "fr") return fr_builds_meta_title(inputs)
	if (locale === "it") return it_builds_meta_title(inputs)
	if (locale === "hu") return hu_builds_meta_title(inputs)
	if (locale === "nl") return nl_builds_meta_title(inputs)
	if (locale === "no") return no_builds_meta_title(inputs)
	if (locale === "pl") return pl_builds_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_builds_meta_title(inputs)
	if (locale === "pt") return pt_builds_meta_title(inputs)
	if (locale === "ro") return ro_builds_meta_title(inputs)
	if (locale === "fi") return fi_builds_meta_title(inputs)
	if (locale === "sv") return sv_builds_meta_title(inputs)
	if (locale === "vi") return vi_builds_meta_title(inputs)
	if (locale === "tr") return tr_builds_meta_title(inputs)
	if (locale === "cs") return cs_builds_meta_title(inputs)
	if (locale === "bg") return bg_builds_meta_title(inputs)
	if (locale === "ru") return ru_builds_meta_title(inputs)
	if (locale === "uk") return uk_builds_meta_title(inputs)
	if (locale === "ar") return ar_builds_meta_title(inputs)
	if (locale === "hi") return hi_builds_meta_title(inputs)
	if (locale === "th") return th_builds_meta_title(inputs)
	if (locale === "ja") return ja_builds_meta_title(inputs)
	if (locale === "zh-CN") return zh_cn2_builds_meta_title(inputs)
	if (locale === "zh-Hant") return zh_hant1_builds_meta_title(inputs)
	return ko_builds_meta_title(inputs)
});
export { builds_meta_title as "builds.meta.title" }